import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Input,
  Balloon,
  Button,
  Checkbox,
  Radio,
  Loading,
} from '@alifd/next';
import { CanvasService } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import SelectGoods from '@/components/SelectGoods';
import TopTitle from '@/components/UI/TopTitle';
import styles from './index.module.scss';
import utils from '@/common/utils';

const venderType = JSON.parse(localStorage.getItem('LZ_CURRENT_SHOP'))?.venderType; // 判断当前店铺是品牌会员还是店铺会员 1-店铺（开卡） 0-品牌
// 报表模式tab选项
const reportType = [
  {
    name: '汇总',
    key: 2,
    label: 2,
  },
  {
    name: '触达',
    key: 0,
    label: 0,
  },
  {
    name: '点击',
    key: 1,
    label: 1,
  },
];
// 报表时间tab选项
const reportTime = [
  {
    name: '近1天',
    key: 1,
    label: 'one',
  },
  {
    name: '近3天',
    key: 3,
    label: 'three',
  },
  {
    name: '近5天',
    key: 5,
    label: 'five',
  },
  {
    name: '近7天',
    key: 7,
    label: 'seven',
  },
];

// 短信数据 数据项
/**
 *  isShow 判断  开卡会员 和 品牌会员 时
 */
const messageData = [
  { name: '点击次数', key: 1, isShow: true },
  { name: '点击人数', key: 2, isShow: true },
  { name: '加购人数', key: 3, isShow: true },
  { name: '商品详情页PV', key: 4, isShow: true },
  { name: '商品详情页UV', key: 5, isShow: true },
  { name: '店铺首页PV', key: 6, isShow: true },
  { name: '店铺首页UV', key: 7, isShow: true },
  { name: '收藏商品人数', key: 8, isShow: true },
  { name: '收藏店铺人数', key: 9, isShow: true },
  { name: '下单人数', key: 10, isShow: true },
  { name: '下单金额', key: 11, isShow: true },
  { name: '下单订单数', key: 12, isShow: true },
  { name: '下单件数', key: 13, isShow: true },
  { name: '付款人数', key: 14, isShow: true },
  { name: '付款金额', key: 15, isShow: true },
  { name: '付款订单数', key: 16, isShow: true },
  { name: '付款件数', key: 17, isShow: true },
  { name: '会员下单用户数', key: 18, isShow: true },
  { name: '会员下单新用户数', key: 19, isShow: true },
  { name: 'CVR', key: 20, isShow: true },
  { name: 'CTR', key: 21, isShow: true },
  { name: 'ROI', key: 22, isShow: true },
];
// 判断 1 是品牌会员 将其数据项 isShow置为true
if (Number(venderType) === 1) {
  messageData[17].isShow = true;
  messageData[19].isShow = true;
} else {
  // 0 是 店铺
  messageData[18].isShow = true;
  messageData[20].isShow = true;
}
// 过滤消息短信数据
const messageDataFilter = messageData.filter((i, index) => {
  return i.isShow === true;
});
// 商品数据 数据项
const goodsData = [
  { name: '浏览PV', key: 1 },
  { name: '浏览UV', key: 2 },
  { name: '加购件数', key: 3 },
  { name: '加购用户数', key: 4 },
  { name: '付款件数', key: 5 },
  { name: '付款用户数', key: 6 },
  { name: '付款金额', key: 7 },
];

export default ({
  activityInfo = {},
  visible = {},
  initData = {},
  runState = {},
  taskInstId = [],
  isPromotion = [],
  showProduct = true,
  onExportVisible = () => {},
  changeData = (data) => {},
  onCancel = () => {},
}) => {
  // // sku商品相关数据定义

  // /**
  //  *    商品sku
  //  *
  //  */
  // 选择商品单选框
  const [goodsSelect, setGoodsSelect] = useState(1);
  // 添加商品弹窗
  const [goodsDialog, setGoodsDialog] = useState(false);
  // 选中的skuid
  const [skuIds, setSkuIds] = useState([]);
  // 选中的商品
  const [selectGoods, setSelectGoods] = useState([]);
  // loading
  const [isLoading, setIsLoading] = useState(false);
  /**
   *   数据导出
   */
  // Tab展示 0：详情，1：任务 3：报表
  const [showTabkey, setShowTabkey] = useState('0');
  // 报表营销类型tab
  const [isActiveType, setActiveType] = useState(2);
  // 报表营销完成时间tab
  const [isActiveTime, setActiveTime] = useState(3);

  // 报表面板数据
  const [reportPane, setReportPane] = useState({
    ordPins: 0,
    payAmount: 0,
    payPins: 0,
    roi: 0,
  });
  const { Tooltip } = Balloon;
  // 报表表格数据
  const [tableData, setTabelData] = useState([]);
  // 报表导出弹窗
  const [exportReport, setExportReport] = useState(false);
  // 导出报表数据的接口，需要的参数
  // 时间维度
  const [timeAll, setTimeAll] = useState(false);
  const [days, setDays] = useState([]);
  const [customize, setCustomize] = useState(false);
  const [customizeObj, setCustomizeObj] = useState({
    customizeStart: '',
    customizeEnd: '',
  });
  // 数据维度
  const [typeAll, setTypeAll] = useState(false);
  const [types, setTypes] = useState([]);

  // 数据项
  // 短信数据
  const [optionAll, setOptionAll] = useState(false);
  const [fields, setFields] = useState([]); // 数据项英文
  const [head, setHead] = useState([]); // 数据项中文
  // 商品数据
  const [goodsAll, setGoodsAll] = useState(false);
  const [skuHead, setSkuHead] = useState([]); // 商品信息中文
  const [skuFields, setSkuFields] = useState([]); // 商品信息英文

  // 组件内部的数据 原表单数据
  const [data, setData] = useState({
    ...initData,
  });
  // 节点运行时详情数据
  const [state, setState] = useState({
    ...runState,
  });
  // 标识短信节点任务执行成功后成功人数信息是否展示（失败不展示）
  const [isSuccessNode, setIsSuccessNode] = useState(
    !!(state.variables && state.variables[0] && state.variables[0].prepNum)
  );

  // 时间维度 全选
  const selectAllTime = (val) => {
    setTimeAll(val);
    if (val) {
      const arr = reportTime.map((i) => {
        return i.key;
      });
      setDays(arr);
    } else {
      setDays([]);
    }
  };
  //  选择时间维度
  const selectDaysFun = (val) => {
    const arr = [];
    reportTime.map((i) => {
      if (val.indexOf(i.key) > -1) {
        arr.push(i.key);
      }
    });
    setDays(arr.sort());
  };
  // 选择数据维度
  const selectTypeFun = (val) => {
    const arr = [];
    reportType.map((i) => {
      for (const value of val) {
        if (i.label === value) {
          arr.push(i.label);
        }
      }
    });
    setTypes(arr);
  };
  // 全选数据维度
  const selectAllType = (val) => {
    setTypeAll(val);
    if (val) {
      const arr = reportType.map((i) => {
        return i.label;
      });
      setTypes(arr);
    } else {
      setTypes([]);
    }
  };
  // 选择 导出短信数据项
  const selectOptionsFun = (val) => {
    const arrBuf = [];
    messageData.map((i) => {
      if (val.indexOf(i.key) > -1) {
        arrBuf.push(i.key);
      }
    });
    setFields(arrBuf);
  };

  // 全选短信数据项选择
  const selectAllOption = (val) => {
    setOptionAll(val);
    if (val) {
      const arrs = messageDataFilter.map((i) => {
        if (i.isShow === true) {
          return i.key;
        }
      });
      setFields(arrs);
    } else {
      setFields([]);
    }
  };
  // 商品数据选择
  const selectGoodsFun = (val) => {
    const arr = [];
    goodsData.map((i) => {
      if (val.indexOf(i.key) > -1) {
        arr.push(i.key);
      }
    });
    setSkuFields(arr);
  };
  // 商品数据 选择 全选
  const selectAllGoods = (val) => {
    setGoodsAll(val);
    if (val) {
      const arr = goodsData.map((i) => {
        return i.key;
      });
      setSkuFields(arr);
    } else {
      setSkuFields([]);
    }
  };
  /**
   * 报表导出，时间维度的自定义天数
   * @param type-时间类型 customizeStart-开始时间，customizeEnd-结束时间
   */
  const customizeChange = (val, type) => {
    const obj = { ...customizeObj };
    // 处理成合法字符串
    val = val.replace(/[^\.\d]/g, '');
    val = val.replace('.', '');
    obj[type] = val;
    // 天数范围要保证在30天以内
    if (parseInt(val) === 0) {
      obj[type] = 1;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    } else if (parseInt(val) > 30) {
      obj[type] = 30;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    } else {
      obj[type] = val;
      setCustomizeObj({
        ...customizeObj,
        ...obj,
      });
    }
  };

  // 校验结束时间是否小于开始时间
  const compareCustomize = () => {
    if (
      parseInt(customizeObj.customizeEnd) <
      parseInt(customizeObj.customizeStart)
    ) {
      LzMsg.error('后一天的数须大于或等于前一天的数');
      setCustomizeObj({
        customizeStart: '',
        customizeEnd: '',
      });
    }
  };

  /**
   * 导出报表
   */
  const exportList = () => {
    if (customize) {
      if (!customizeObj.customizeStart || !customizeObj.customizeEnd) {
        LzMsg.error('请选择自定义的时间维度');
        return;
      } else if (customizeObj.customizeStart > customizeObj.customizeEnd) {
        LzMsg.error('请设置正确的自定义的时间维度');
        return;
      }
    }
    if (
      days.length === 0 &&
      !customizeObj.customizeStart &&
      !customizeObj.customizeEnd
    ) {
      // 回到顶部
      parent.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      LzMsg.error('请先选择需要导出的时间维度');
      return;
    }
    // if (!typeAll && types.length === 0) {
    //   // 回到顶部
    //   parent.scrollTo(0, 0);
    //   document.documentElement.scrollTop = 0;
    //   LzMsg.error('请先选择需要导出的数据维度');
    //   return;
    // }
    // 导出的短信数据项和导出的商品数据项请至少选一个
    // if (skuFields.length === 0 && fields.length == 0) {
    //   // 回到顶部
    //   parent.scrollTo(0, 0);
    //   document.documentElement.scrollTop = 0;
    //   LzMsg.error('导出的短信数据项和导出的商品数据项请至少选一个');
    //   return;
    // }
    // 选择 自定义选择商品但是商品skuid列表为空
    // if (goodsSelect === 2 && skuIds.length < 1) {
    //   // 回到顶部
    //   parent.scrollTo(0, 0);
    //   document.documentElement.scrollTop = 0;
    //   LzMsg.error('请先选择自定义选择商品');
    //   return;
    // }

    // 拼出 短信数据 数据项选择的中文数组，后端需要用这个做excel表头
    messageData.forEach((item) => {
      //  item.isShow===true
      if (fields.indexOf(item.key) > -1 && item.isShow === true) {
        head.push(item.name);
      }
    });
    // 拼出 商品数据 数据项选择的中文数组
    // goodsData.forEach((item) => {
    //   if (skuFields.indexOf(item.key) > -1) {
    //     skuHead.push(item.name);
    //   }
    // });
    // taskInstId
    const taskInstIdList = taskInstId;

    const param = {
      taskInstIds: taskInstIdList || [],
      days, // 时间维度
      dimension: types, // 数据维度
      marketShowDatas: fields, // 短信数据项
      customDayStart: customize ? customizeObj.customizeStart : 0, // 自定义时间左
      customDayEnd: customize ? customizeObj.customizeEnd : 0, // 自定义时间右
      // skuShowDatas: skuFields, // 商品数据选择
      // skuIds: skuIds.length > 0 ? skuIds.toString() : null, // 字符串
    };
    setIsLoading(true);
    CanvasService.newBatchExport(param)
      .then((res) => {
        // 关闭弹窗
        onExportVisible();
        utils.downloadFile(res);
        if (res.success) {
          LzMsg.success('数据导出成功');
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
        parent.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    });
  };

  /**
   * 清空所有下载选框的选择
   */
  const clearForm = () => {
    // 时间维度
    setTimeAll(false);
    setDays([]);
    setCustomize(false);
    // 自定义是时间
    setCustomizeObj({
      customizeStart: null,
      customizeEnd: null,
    });

    // 数据维度
    setTypeAll(false);
    setTypes([]);
    // 数据项
    setOptionAll(false);
    setFields([]);
    // 关闭弹窗
    onExportVisible(false);
  };

  /**
   * 查询报表数据-面板数据
   * @param v.flag-左侧不同维度切换
   * @param v.time-右侧时间切换
   */
  const getSMSSummaryEffect = (v) => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    const params = {
      flag: v.flag,
      startTime: startT,
      endTime: startT + 86400000 * (v.time - 1),
      taskInstId: state.activityInfo.jobId,
    };
    CanvasService.getSMSSummaryEffect(params)
      .then((res) => {
        setReportPane(res.data);
      })
      .catch((e) => {
        parent.scrollTo(0, 0);
        console.log(e);
        document.documentElement.scrollTop = 0;
      });
  };

  /**
   * 查询列表数据
   */
  const getSMSTaskEffect = (v) => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    const param = {
      flag: isActiveType,
      startTime: startT,
      endTime: startT + 86400000 * (isActiveTime - 1), // isActiveTime是选择的时间范围，3，5，7日内，所以把开始时间累加上去
      taskInstId: state.activityInfo.jobId,
      ...v,
    };
    // CanvasService.getSMSTaskEffect(param).then(res => {
    //   setTabelData(res.data.smsEffectResponseList);
    // })
  };

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  useEffect(() => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    if (
      showTabkey === '2' &&
      state.activityInfo &&
      state.activityInfo.startTime
    ) {
      getSMSSummaryEffect({ flag: isActiveType, time: isActiveTime });
      getSMSTaskEffect();
    }
  }, [showTabkey]);

  return (
    <div
      className={`${styles.detailRoot} ${styles.sendMessageRoot}`}
    >
      <div
        className={`${styles['small-export-report']}`}
        style={{
          width: '100%',
        }}
      >
        <div style={{ margin: 30 }}>
          <TopTitle title='导出数据维度选择'/>
          {/* 导出时间维度选择 */}
          <div className={`${styles['display-flex']} times-item`}>
            <div style={{ width: '100%' }}>
              <div style={{ width: '100%' }} className={styles.ballon}>
                导出时间维度选择:
                <Tooltip
                  align="t"
                  alignEdge
                  closable={false}
                  style={{ color: '#9ca7b6', paddingLeft: '5px' }}
                  trigger={<span className="iconfont icon-icon4-33" />}
                >
                  <span>以发送时间起始，可导出30日内的效果数据。</span>
                </Tooltip>
              </div>
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
              <Checkbox
                className="export-checkbox"
                checked={timeAll}
                onChange={(timeAll) => {
                  selectAllTime(timeAll);
                }}
              >
                全选
              </Checkbox>
              <div style={{ width: '40%', display: 'flex' }}>
                <Checkbox.Group
                  value={days}
                  onChange={(days) => {
                    if (days.length == 4) {
                      setTimeAll(true);
                    } else {
                      setTimeAll(false);
                    }
                    selectDaysFun(days);
                  }}
                  className={styles.timeCheck}
                >
                  {reportTime.map((i, index) => (
                    <Checkbox style={{}} key={i.key} value={i.key}>
                      {i.name}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
              <Checkbox
                checked={customize}
                onChange={(value) => {
                  setCustomize(value);
                }}
              >
                自定义 (不支持商品数据) :
              </Checkbox>
              <Input
                style={{ width: '8%', marginLeft: '15px' }}
                disabled={!customize}
                value={customizeObj.customizeStart}
                onChange={(val) => customizeChange(val, 'customizeStart')}
                onBlur={() => compareCustomize}
              />
              <span style={{ marginLeft: '15px' }}>天~</span>
              <Input
                style={{ width: '8%', marginLeft: '15px' }}
                disabled={!customize}
                value={customizeObj.customizeEnd}
                onChange={(val) => customizeChange(val, 'customizeEnd')}
                onBlur={() => compareCustomize}
              />
              <span style={{ marginLeft: '15px' }}>天</span>
            </div>
          </div>
          {/* 导出数据维度选择: */}
          {/* <div
            className={`${styles['display-flex']}`}
            style={{ paddingBottom: '20px' }}
          >
            <div className={`${styles['inline-block-item']}`}>
              <span>导出数据维度选择: </span>
            </div>
            <div style={{ width: '100%', display: 'flex' }}>
              <Checkbox
                className="export-checkbox"
                checked={typeAll}
                onChange={(typeAll) => selectAllType(typeAll)}
              >
                全选
              </Checkbox>
              <div style={{ width: '40%', display: 'flex' }}>
                <Checkbox.Group
                  value={types}
                  onChange={(types) => {
                    if (types.length === 3) {
                      setTypeAll(true);
                    } else {
                      setTypeAll(false);
                    }
                    selectTypeFun(types);
                  }}
                  style={{ width: '100%' }}
                >
                  {reportType.map((i, index) => (
                    <Checkbox
                      style={{ width: '23%' }}
                      key={i.key}
                      value={i.label}
                    >
                      {i.name}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            </div>
          </div> */}
          {/* 短信数据标题 */}
          {/* <div
            style={{
              paddingBottom: '10px',
              marginTop: '30px',
            }}
          >
            <TopTitle title='营销数据'/>
          </div> */}
          {/* 数据项 */}
          {/* <div
            className={`${styles['display-flex']} options-item`}
            style={{ alignItems: 'flex-start' }}
          >
            <div className={`${styles['inline-block-item']}`}>
              <span>导出营销数据项选择 </span>
            </div>
            <div
              style={{ width: '100%', display: 'flex', paddingBottom: '20px' }}
            >
              <Checkbox
                className="export-checkbox"
                checked={optionAll}
                onChange={(optionAll) => selectAllOption(optionAll)}
              >
                全选
              </Checkbox>
              <div style={{ width: '90%', display: 'flex' }}>
                <Checkbox.Group
                  value={fields}
                  onChange={(fields) => {
                    if (fields.length === 21) {
                      setOptionAll(true);
                    } else {
                      setOptionAll(false);
                    }
                    selectOptionsFun(fields);
                  }}
                  style={{ width: '100%' }}
                >
                  {messageDataFilter.map((i, index) => (
                    <Checkbox
                      style={{ width: '23%' }}
                      key={i.key}
                      value={i.key}
                    >
                      {i.name}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            </div>
          </div> */}
          {/* 商品数据标题 */}
          {/* {showProduct && <div
            style={{
              paddingBottom: '10px',
              marginTop: '30px',
            }}
          >
            <TopTitle title='商品数据'/>
          </div>} */}
          {/* 导出商品数据项选择 */}
          {/* {showProduct && <div
            className={`${styles['display-flex']} options-item`}
            style={{ alignItems: 'flex-start', paddingBottom: '20px' }}
          >
            <div className={`${styles['inline-block-item']}`}>
              <span>导出商品数据项选择 </span>
            </div>
            <div
              style={{
                maxWidth: '100%',
                display: 'flex',
                paddingBottom: '20px',
              }}
            >
              <Checkbox
                className="export-checkbox"
                checked={goodsAll}
                onChange={(goodsAll) => selectAllGoods(goodsAll)}
              >
                全选
              </Checkbox>
              <div style={{ width: '90%', display: 'flex' }}>
                <Checkbox.Group
                  value={skuFields}
                  onChange={(skuFields) => {
                    if (skuFields.length === 7) {
                      setGoodsAll(true);
                    } else {
                      setGoodsAll(false);
                    }
                    selectGoodsFun(skuFields);
                  }}
                  style={{ width: '100%' }}
                >
                  {goodsData.map((i, index) => (
                    <Checkbox
                      style={{ width: '23%' }}
                      key={i.key}
                      value={i.key}
                    >
                      {i.name}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            </div>
            <div className={`${styles['inline-block-item']}`}>
              <span>导出商品选择 </span>
            </div>
            <div>
              <Radio.Group
                direction="hoz"
                value={goodsSelect}
                onChange={(value) => {
                  setGoodsSelect(value);
                }}
              >
                <Radio value={1}>默认TOP100</Radio>
                <Radio value={2}>
                  自定义选择商品
                  <span style={{ color: '#FF3333' }}>
                    (注:若筛选的商品未进入付款、浏览、加购商品用户数的TOP100，则无法获取相关商品效果数据，请知悉。)
                  </span>
                </Radio>
              </Radio.Group>
            </div>

            {goodsSelect === 2 ? (
              <div style={{ alignItems: 'flex-start' }}>
                <div className={`${styles['inline-block-item']}`} />
                <div
                  style={{
                    width: '100%',
                    padding: '20px 0px 20px 20px',
                    background: '#FFFFFF',
                    border: '1px solid #D7DDE4',
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => {
                      // failSku = 0;
                      // setImportSku([]);
                      // searchSku();
                      setGoodsDialog(true);
                    }}
                  >
                    选择商品
                  </Button>
                  <span style={{ marginLeft: '15px' }}>
                    已选择
                    <span style={{ color: '#FF3333' }}>
                      {selectGoods.length}
                    </span>
                    个
                  </span>
                </div>
              </div>
            ) : (
              <span />
            )}
          </div>} */}
        </div>
        <div className={styles.footer}>
          <Button
            type="normal"
            style={{ height: '30px', marginRight: '10px', width: 88 }}
            onClick={clearForm}
          >
            取消
          </Button>
          <Button
            type="primary"
            style={{ height: '30px' }}
            onClick={exportList}
          >
            确认导出
          </Button>
        </div>
      </div>
      {/* <SelectGoods
        goodsDialog={goodsDialog}
        closeDialog={() => setGoodsDialog(false)}
        skuIds={skuIds}
        confirmSkuid={(v) => setSkuIds(v)}
        selectGoods={selectGoods}
        confirmGoods={(v) => setSelectGoods(v)}
      /> */}
      {/* </div>
      </LzDialog> */}
      <Loading
        visible={isLoading}
        fullScreen
        // shape="fusion-reactor"
      />
    </div>
  );
};
